const WORD_CATEGORY_GROUP_LABELS = {
  1.1: "첫걸음 초급 단어",
  1.2: "첫걸음 초급 단어",
  1.3: "첫걸음 초급 단어",
  1.4: "첫걸음 초급 단어",
  2.1: "한국 여행에서 사용하는 쉬운 단어",
  2.2: "한국 여행에서 사용하는 쉬운 단어",
  2.3: "한국 여행에서 사용하는 쉬운 단어",
  2.4: "한국 여행에서 사용하는 쉬운 단어",
  3.1: "K-pop·K드라마에 자주 나오는 표현",
  3.2: "K-pop·K드라마에 자주 나오는 표현",
  3.3: "K-pop·K드라마에 자주 나오는 표현",
  3.4: "K-pop·K드라마에 자주 나오는 표현",
  4.1: "식당·카페에서 당황하지 않고 주문하기",
  4.2: "식당·카페에서 당황하지 않고 주문하기",
  4.3: "식당·카페에서 당황하지 않고 주문하기",
  4.4: "식당·카페에서 당황하지 않고 주문하기",
  5.1: "한국인이 매일 쓰는 생활 단어",
  5.2: "한국인이 매일 쓰는 생활 단어",
  5.3: "한국인이 매일 쓰는 생활 단어",
  5.4: "한국인이 매일 쓰는 생활 단어",
  6.1: "지하철·버스에서 꼭 쓰는 표현",
  6.2: "지하철·버스에서 꼭 쓰는 표현",
  6.3: "지하철·버스에서 꼭 쓰는 표현",
  6.4: "지하철·버스에서 꼭 쓰는 표현",
  7.1: "한국인이 자주 쓰는 감정 표현",
  7.2: "한국인이 자주 쓰는 감정 표현",
  7.3: "한국인이 자주 쓰는 감정 표현",
  7.4: "한국인이 자주 쓰는 감정 표현",
  8.1: "한국인들이 많이 사용하는 중급 단어",
  8.2: "한국인들이 많이 사용하는 중급 단어",
  8.3: "한국인들이 많이 사용하는 중급 단어",
  8.4: "한국인들이 많이 사용하는 중급 단어",
  9.1: "병원·약국에서 필요한 생활 표현",
  9.2: "병원·약국에서 필요한 생활 표현",
  9.3: "병원·약국에서 필요한 생활 표현",
  9.4: "병원·약국에서 필요한 생활 표현",
  10.1: "비즈니스 고급 표현",
  10.2: "비즈니스 고급 표현",
  10.3: "비즈니스 고급 표현",
  10.4: "비즈니스 고급 표현",
};

export function getWordCategoryDisplayName(name) {
  const groupLabel = WORD_CATEGORY_GROUP_LABELS[name] || "";
  return groupLabel ? `${name} ${groupLabel}` : name;
}
